import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/Services/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  showPassword = false;
  isLoading = false;
  noEmail = false;
  noPassword = false;
  invalidCredentials = false;
  serverError = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(4)]],
      rememberMe: [false]
    });
  }

  ngOnInit(): void {
    // Initialize any additional logic if needed
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  async onSubmit() {
    this.noEmail = false;
    this.noPassword = false;

    if (this.loginForm.valid) {
      this.isLoading = true;
      this.invalidCredentials = false;
      this.serverError = false;

      try {
        const data = await this.authService.login(this.loginForm.value['email'], this.loginForm.value['password']);
        if (data && data.access_token) {
          // navigate to url
          const url = localStorage.getItem('redirectUrl') || '';
          window.location.href = url + '?token=' + data.access_token + '&userId=' + data.user.userId + '&orgId=' + data.user.organisationId + '&expiry=' + data.expires_in;
        } else {
          this.invalidCredentials = true;
        }
      } catch (error) {
        if (error && error.error && (error.error.Message === 'Invalid email' || error.error.Message === 'Incorrect password')) {
          this.invalidCredentials = true;
        }
        else {
          this.serverError = true;
        }
      }
      this.isLoading = false;
    }
    else if (!this.loginForm.value['email']) {
      this.noEmail = true;
    }
    else if (!this.loginForm.value['password']) {
      this.noPassword = true;
    }
  }

}
